import { PostPipeline } from "../../plugins/global/PostEffectPlugin";
import BaseScene, { BaseSceneConfig } from "../BaseScene";
import PauseScreen from "../../components/ncsc/PauseScreen";
import AnimatedFeedback from "../../components/ncsc/AnimatedFeedback";

export default class MiniGameScene extends BaseScene {
  private key: string;
  private paused: boolean = true;
  public pauseCam: Phaser.Cameras.Scene2D.Camera;

  private mask: Phaser.GameObjects.Graphics;
  private maskProgress: number = 0;
  private cameraHype: number;

  private TRANSITION_SPEED: number = 500;
  private TRANSITION_EASE: string = "Quart.easeIn";

  private maskCamera: Phaser.Cameras.Scene2D.Camera;

  public pauseButton: Phaser.GameObjects.Image;
  private pauseScreenVisible: boolean = false;

  private fbAnim: AnimatedFeedback;

  private effects: boolean;

  constructor(config: BaseSceneConfig) {
    super(config);
    this.key = config.key;
  }

  preload() {
    super.preload();
    //TODO: if webgl renederer not avalible.

    this.effects = this.sponge.effects.addMiniGamePost(this);


    if(this.effects){
    (this.cameras.main.pipeline as PostPipeline).effectProgress = 0;
    (this.cameras.main
      .pipeline as PostPipeline).transitionType = Phaser.Math.RND.integerInRange(
      0,
      2
    );

      } else {
        //todo: mask screen
        const shape1 = this.make.graphics({}, false).fillRect(0, 160, 720, 1280 - 160)
        const geomask1 = shape1.createGeometryMask();
        this.cameras.main.setMask(geomask1);
      }

  }

  create() {
    super.create();
    this.add.image(this.cameras.main.centerX, 140,"blurEdge").setOrigin(0.5,0).setDisplaySize(720,1200)

    // const headerBg = this.add.graphics();
    // headerBg.fillStyle(0x000000,1);
    // headerBg.fillRect(0,0,720,160);


    this.pauseCam = this.cameras.add(540,0, 180, 150, false, "pauseCam");
    this.pauseCam.setViewport(540,0,180,150)

    const shape1 = this.make.graphics({}, false).fillRect(540,0,180,150)
    const geomask1 = shape1.createGeometryMask();
    this.pauseCam.setMask(geomask1);

    // this.pauseCam.setBackgroundColor("rgba(1,0,0,0);");

    
    this.setupIntroMask();
    
    
    this.fbAnim = new AnimatedFeedback(this);
    this.fbAnim.on("animatedFeedbackComplete",this.showFinalFeedback, this)
    this.fbAnim.setVisible(false);
    this.pauseCam.ignore(this.fbAnim);
    
    
    
    // this.time.delayedCall(1000, () => {});
    
  }

  startGame(){
    if (this.key === "TapOutScene" || this.key === "CloudCatcherScene"){
      if (this.sponge.data.save.seenInstructions.indexOf(this.key) >= 0){
        //skip instructions but show optional button to launch if needed
        this.paused = false;
        this.start();
      }else{
        //shown instructions a second time
        this.saveKeyToTrackingModel(this.key);
      }
    }
    else if (this.sponge.data.save.seenInstructions.indexOf(this.key) === -1) {
     //skip instructions but show optional button to launch if needed
      this.saveKeyToTrackingModel(this.key);
    } else {
      //skip instructions
      this.paused = false;
      this.start();
      
    }
    this.showPauseControl();
  }

  setupIntroMask() {

    if(!this.effects){
      this.time.delayedCall(500,()=>{
        this.startGame();
      }) 
      return;
    }


    this.add.tween({
      targets: this.cameras.main.pipeline as PostPipeline,
      effectProgress: 1.2,
      duration: this.TRANSITION_SPEED,
      ease: this.TRANSITION_EASE,
      onUpdate: () => {
        // console.log("update");
      },
      onComplete: () => {
        this.startGame();
      },
    });
  }

  saveKeyToTrackingModel(key: string){
    this.sponge.popup.launchPopup("instructions-" + key, () => {
      
      this.sponge.data.save.seenInstructions.push(key);
      this.sponge.tracking.save();

      this.paused = false;
      this.start();
    });
  }

  start() {
    console.log("startMiniGame");
  }

  showPauseControl(){
    console.warn(">>>>>>>>>>>>>>showPauseControl", this);

    const pauseBG = this.add.graphics({x:0,y:0});
    // pauseBG.fillStyle(0xFF00AA,1);
    // pauseBG.fillRect(0,0,200,160)

    this.pauseButton = this.add.image(2, 80,"runner-atlas","hud-fill-right.png").setOrigin(0,0.5);
    this.cameras.main.ignore([pauseBG,this.pauseButton]);

    console.log(this.pauseButton);

    this.pauseButton.setInteractive({ useHandCursor: true });
      this.pauseButton.on("pointerup", () => {

        if(this.pauseScreenVisible){
          return;
        }

        this.paused = true;
        this.pauseScreenVisible = true;
        this.pauseButton.disableInteractive();
        const ps = new PauseScreen(this,"instructions-"+ this.key);
        ps.on("closeAndGoHome",this.goHome, this);
        ps.on("resumePressed", this.resumeAllActions, this);
        ps.on("restartPressed", this.restartGameCalled, this);
        
        this.children.bringToTop(ps);
        this.pauseAllActions();
      });

      this.pauseButton.on("pointerover", () => {this.pauseButton.setFrame("hud-fill-right-hover.png")});
      this.pauseButton.on("pointerout", () => {this.pauseButton.setFrame("hud-fill-right.png")});
  }

  restartGameCalled(){
    //
    this.scene.stop(this.key);
    this.game.events.emit("mini-game-restart");
  }

  goHome(){
    //  
    this.scene.stop(this.key);
    this.game.events.emit("mini-game-go-home");
  }

  resumeAllActions(){
    //
    this.paused = false;
    this.pauseScreenVisible = false;
    this.pauseButton.setInteractive();

    console.warn("minigame resume / unpaused")
  }

  pauseAllActions(){
    //
  }

  closeMiniGame(score: number): void {
    this.game.events.emit("mini-game-complete", this.key, score);
    // this.scene.stop(this.key);


    if(!this.effects){
      this.scene.stop(this.key);
      return;
    }

    (this.cameras.main
      .pipeline as PostPipeline).transitionType = Phaser.Math.RND.integerInRange(
      0,
      2
    );

    this.add.tween({
      targets: this.cameras.main.pipeline as PostPipeline,
      effectProgress: 0,
      ease: "Quart.easeOut",
      duration: this.TRANSITION_SPEED,
      maskProgress: 0,
      onUpdate: () => {
        //
      },
      onComplete: () => {
        this.scene.stop(this.key);
      },
    });
  }

  complete(score: number): void {
    //destroy? or mini game handle own shutdown?

    const isCorrect = score === 1 ? true:false;

    this.fbAnim.setVisible(true);
    this.fbAnim.setDepth(100)
    this.fbAnim.createDisplay(isCorrect);
    

    
  }

  showFinalFeedback(isCorrect: boolean){
    this.fbAnim.setVisible(false);

    const score = isCorrect ? 1:0;
    if (
      score === 1 &&
      this.sponge.data.save.seenCorrectFeedback.indexOf(this.key) === -1
    ) {
      this.sponge.data.save.seenCorrectFeedback.push(this.key);
      this.sponge.tracking.save();

      this.sponge.popup.launchPopup("correct-feedback-" + this.key, () => {
        this.closeMiniGame(score);
      });
    } else if (score === 0) {
      this.sponge.popup.launchPopup("incorrect-feedback-" + this.key, () => {
        this.closeMiniGame(score);
      });
    } else {
      this.closeMiniGame(score);
    }
  }
}
